import { render, staticRenderFns } from "./ModalPaginaConstrucao.vue?vue&type=template&id=f151fa56&scoped=true"
import script from "./ModalPaginaConstrucao.vue?vue&type=script&lang=js"
export * from "./ModalPaginaConstrucao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f151fa56",
  null
  
)

export default component.exports